"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gridContext = require("./grid-context");

var _core = require("@emotion/core");

var _grid = _interopRequireDefault(require("./grid"));

var _spacing = _interopRequireDefault(require("./spacing"));

var _breakpoints = require("../mixins/breakpoints");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n      grid-template-columns: repeat(", ", 1fr);\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n      grid-template-columns: repeat(", ", 1fr);\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var gridColumns = function gridColumns(props) {
  return (
    /*#__PURE__*/
    (0, _core.css)("@supports (display:grid){", _breakpoints.breakpoint.sm(_templateObject(), props.layout === 1 ? '8' : '4'), " ", _breakpoints.breakpointAndDesktop.lg(_templateObject2(), props.layout === 1 ? '12' : '8'), ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"))
  );
};

var StyledRow = (
/*#__PURE__*/
0, _styledBase["default"])('div', {
  target: "e15r1ymc0",
  label: "StyledRow"
})(_grid["default"].grid, " ", _grid["default"].close, " & > div{@media only screen and (-ms-high-contrast:none){margin-right:", _spacing["default"].Large, ";}&:last-child{margin-right:0;margin-bottom:0;}}", function (props) {
  return props.column === 1 ? gridColumns(props) : null;
}, " @media only screen and (-ms-high-contrast:none){margin-bottom:", _spacing["default"].Close, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
/** // Row Component
 * import { Layout } from '@kbbcomponentlibrary/principles';
 * const { Row } = Layout;
 * */

var Row = function Row(props) {
  return (0, _core.jsx)(_gridContext.LayoutContext.Consumer, null, function (layout) {
    return (0, _core.jsx)(_gridContext.ColContext.Consumer, null, function (column) {
      return (0, _core.jsx)(StyledRow, (0, _extends2["default"])({
        layout: layout,
        column: column
      }, props));
    });
  });
};

Row.displayName = 'Row';
Row.propTypes = {
  children: _propTypes["default"].node
};
var _default = Row;
exports["default"] = _default;
Row.__docgenInfo = {
  "description": "// Row Component\nimport { Layout } from '@kbbcomponentlibrary/principles';\nconst { Row } = Layout;",
  "methods": [],
  "displayName": "Row",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    }
  }
};

if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["src/Layout/Row.js"] = {
    name: "Row",
    docgenInfo: Row.__docgenInfo,
    path: "src/Layout/Row.js"
  };
}